import { render, staticRenderFns } from "./Panier.vue?vue&type=template&id=fdabf438&scoped=true&"
import script from "./Panier.js?vue&type=script&lang=js&"
export * from "./Panier.js?vue&type=script&lang=js&"
import style0 from "./Panier.scoped.scss?vue&type=style&index=0&id=fdabf438&lang=scss&scoped=true&"
import style1 from "./Panier.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdabf438",
  null
  
)

export default component.exports